import type { SelectOption } from './SelectOption';

export const YES_NO_OPTIONS: SelectOption[] = [
  { value: 'Yes', text: 'Yes' },
  { value: 'No', text: 'No' },
];

export const MSDE_APP_HELP_EMAIL = 'mdeapps@mdek12.org';

export const MAX_DATE = new Date('2999-12-31');

export const SENIOR_SNAPSHOT_US_HISTORY_HIDE_YEAR = 2026;

export enum TOKEN_KEYS {
  ROLES = 'roles',
  EXPIRATION = 'exp',
  DISTRICT_ACCESS = 'extn.msis2district',
}
